export default __webpack_public_path__ + "static/media/Dr-Nikolay-Shkilev.2f2b27f1.jpg";